import { render, staticRenderFns } from "./underline.vue?vue&type=template&id=3bf4cb54&"
import script from "./underline.vue?vue&type=script&lang=js&"
export * from "./underline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports